export function generateCaptcha() {
    var num1 = Math.floor(Math.random() * 100) + 1;
    var num2 = Math.floor(Math.random() * 100) + 1;
    var operators = ['+', '-', '*'];
    var operator = operators[Math.floor(Math.random() * operators.length)];
    var equation = num1 + ' ' + operator + ' ' + num2;
    return equation;
  }